<template>
  <div>
    <Movementmenu />
    <v-container fluid class="grey lighten-4 pa-6">
      <v-row dense class="mb-4">
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg shadow-sm" color="blue darken-2" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">รายการทั้งหมด</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.total }} <small class="caption">รายการ</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="blue darken-1">
                <v-icon size="30">mdi-clipboard-list-outline</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg shadow-sm" color="red darken-1" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">ขาดเกณฑ์ (ต้องการ)</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.shortage }} <small class="caption">แห่ง</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="red darken-2">
                <v-icon size="30">mdi-account-alert</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg shadow-sm" color="amber darken-2" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">เกินเกณฑ์ (ต้องย้าย)</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.surplus }} <small class="caption">แห่ง</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="amber darken-3">
                <v-icon size="30">mdi-account-multiple-plus</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg shadow-sm" color="green darken-1" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">พอดีเกณฑ์</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.balanced }} <small class="caption">แห่ง</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="green darken-2">
                <v-icon size="30">mdi-check-circle-outline</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <base-material-card
        icon="mdi-format-list-checks"
        title="ข้อมูลอัตรากำลัง ขาด/เกิน ประกอบการพิจารณาย้าย"
        color="success"
        class="px-5 py-3"
      >
        <v-card flat class="grey lighten-5 rounded-lg mb-4 pa-4">
          <v-row align="center">
            <v-col cols="12" md="8" class="d-flex flex-wrap" style="gap: 10px;">
              <v-btn
                small
                rounded
                color="indigo"
                dark
                @click="man_powersummaryCSV()"
              >
                <v-icon left>mdi-file-import</v-icon> นำเข้า CSV
              </v-btn>
              <v-btn
                small
                rounded
                color="success"
                outlined
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> ส่งออก Excel
              </v-btn>
              <v-btn
                small
                rounded
                color="error"
                outlined
                @click="man_powersummaryClear()"
              >
                <v-icon left>mdi-delete-sweep</v-icon> ล้างข้อมูล
              </v-btn>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="ค้นหา (สถานศึกษา, จังหวัด, สถานะ)"
                outlined
                dense
                rounded
                hide-details
                class="bg-white"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>

        <v-data-table
          :headers="headers"
          :items="man_powersummarys"
          :search="search"
          :loading="loading"
          class="elevation-0 custom-table"
        >
          <template v-slot:item.summary_s="{ item }">
            <v-chip
              :color="getStatusColor(item.summary_s)"
              dark
              small
              label
              class="font-weight-bold"
            >
              <v-icon left x-small>{{ getStatusIcon(item.summary_s) }}</v-icon>
              {{ item.summary_s }}
            </v-chip>
          </template>

          <template v-slot:item.total_s="{ item }">
            <span class="font-weight-bold">{{ item.total_s }}</span> อัตรา
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="amber darken-2"
                  @click.stop="man_powersummaryEdit(item.id_no)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>แก้ไขข้อมูล</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </base-material-card>

      <v-dialog
        v-model="editman_powersummarydialog"
        persistent
        max-width="500px"
      >
        <v-card class="rounded-lg">
          <v-toolbar color="amber darken-1" dark flat>
            <v-icon left>mdi-file-edit</v-icon>
            <v-toolbar-title>แก้ไขข้อมูลอัตรากำลัง</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="editman_powersummarydialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-6">
            <div class="subtitle-1 font-weight-bold mb-4 text-center">
              {{ editman_powersummary.college_name }}
            </div>
            <v-form ref="editman_powersummaryform" lazy-validation>
              <v-autocomplete
                v-model="editman_powersummary.summary_s"
                :items="summaryText"
                item-text="text"
                item-value="value"
                label="สถานะสรุปผล"
                outlined
                rounded
                dense
                required
                :rules="[v => !!v || 'กรุณาเลือกสถานะ']"
              ></v-autocomplete>

              <v-text-field
                v-model="editman_powersummary.total_s"
                label="จำนวน (อัตรา)"
                type="number"
                outlined
                rounded
                dense
                required
                :rules="[v => !!v || 'กรุณาระบุจำนวน']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end pa-4 grey lighten-5">
            <v-btn text @click="editman_powersummarydialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="amber darken-2"
              depressed
              dark
              @click="editman_powersummarySubmit"
              >บันทึกการแก้ไข</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="ClearMan_powerdialog" persistent max-width="450px">
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon color="error" class="mr-2">mdi-delete-alert</v-icon>
            ล้างข้อมูลทั้งหมด
          </v-card-title>
          <v-card-text>
            <div class="subtitle-1 error--text font-weight-bold">
              คำเตือน: ข้อมูลอัตรากำลังทั้งหมดจะถูกลบ
            </div>
            <div class="body-2 mt-2">
              ยืนยันที่จะดำเนินการต่อหรือไม่? การกระทำนี้ไม่สามารถกู้คืนได้
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="ClearMan_powerdialog = false">ยกเลิก</v-btn>
            <v-btn color="error" depressed @click="ClearMan_powerSubmit"
              >ยืนยันล้างข้อมูล</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ================= CSV IMPORT DIALOG (เพิ่มการตรวจสอบไฟล์ก่อนนำเข้า) ================= -->
      <v-dialog
        v-model="man_powersummaryCSVdialog"
        persistent
        max-width="600px"
      >
        <v-card class="rounded-lg">
          <v-toolbar color="indigo" dark flat>
            <v-icon left>mdi-file-import</v-icon>
            <v-toolbar-title>นำเข้าไฟล์ CSV</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeCsvDialog"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-6">
            <v-btn
              block
              outlined
              color="info"
              class="mb-4"
              to="/admin/man_powersummary_import/"
              target="_blank"
            >
              <v-icon left>mdi-download</v-icon> ดาวน์โหลดแบบฟอร์มตัวอย่าง
            </v-btn>

            <v-file-input
              v-model="file2"
              accept=".csv"
              label="เลือกไฟล์ .csv"
              outlined
              rounded
              dense
              prepend-icon="mdi-paperclip"
              show-size
              :disabled="csvValidating"
              @change="onFileSelected"
            ></v-file-input>

            <v-alert
              v-if="csvValidating"
              type="info"
              dense
              text
              class="mb-0"
            >
              <div class="d-flex align-center">
                <v-progress-circular
                  indeterminate
                  size="18"
                  width="2"
                  color="info"
                  class="mr-2"
                ></v-progress-circular>
                กำลังตรวจสอบความถูกต้องของไฟล์...
              </div>
            </v-alert>

            <v-alert
              v-if="csvValidation.checked && csvValidation.valid"
              type="success"
              dense
              text
              class="mb-2"
            >
              <v-icon left small>mdi-check-circle</v-icon>
              ไฟล์ถูกต้อง พร้อมนำเข้าข้อมูล {{ csvValidation.totalRows }} แถว
            </v-alert>

            <v-alert
              v-if="csvValidation.checked && !csvValidation.valid"
              type="error"
              dense
              text
              class="mb-2"
            >
              <v-icon left small>mdi-alert-circle</v-icon>
              พบข้อผิดพลาด {{ csvValidation.errors.length }} รายการ
              จากทั้งหมด {{ csvValidation.totalRows }} แถว
              กรุณาแก้ไขไฟล์แล้วเลือกใหม่อีกครั้ง
            </v-alert>

            <v-card
              v-if="csvValidation.checked && csvValidation.errors.length > 0"
              outlined
              class="mb-2"
              style="max-height: 220px; overflow-y: auto;"
            >
              <v-list dense>
                <v-list-item
                  v-for="(err, idx) in csvValidation.errors"
                  :key="idx"
                >
                  <v-list-item-content>
                    <v-list-item-title class="error--text font-weight-bold">
                      แถวที่ {{ err.row }}
                      <span v-if="err.college_code">
                        (รหัส: {{ err.college_code }})</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-for="(msg, mIdx) in err.messages"
                      :key="mIdx"
                      class="text-wrap"
                    >
                      • {{ msg }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>

            <v-card
              v-if="csvValidation.checked && csvValidation.preview.length > 0"
              outlined
              class="mt-2"
            >
              <v-card-subtitle class="pb-0"
                >ตัวอย่างข้อมูล (5 แถวแรก)</v-card-subtitle
              >
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>แถว</th>
                      <th>รหัสสถานศึกษา</th>
                      <th>สถานะ</th>
                      <th>จำนวน</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(row, idx) in csvValidation.preview"
                      :key="idx"
                    >
                      <td>{{ row.row }}</td>
                      <td>{{ row.college_code }}</td>
                      <td>{{ row.summary_s }}</td>
                      <td>{{ row.total_s }}</td>
                      <td>
                        <v-icon v-if="row.valid" color="success" small
                          >mdi-check</v-icon
                        >
                        <v-icon v-else color="error" small
                          >mdi-close</v-icon
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="closeCsvDialog">ยกเลิก</v-btn>
            <v-btn
              color="indigo"
              depressed
              dark
              :loading="csvUploading"
              :disabled="!canImport"
              @click="csvManpowerSubmit"
              >นำเข้าข้อมูล</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        top
        right
        rounded="pill"
      >
        <v-icon left>{{ snackbar.icon }}</v-icon> {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // ต้องติดตั้ง: npm install xlsx

export default {
  components: { Movementmenu },
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      search: "",
      file2: null,

      editman_powersummarydialog: false,
      ClearMan_powerdialog: false,
      man_powersummaryCSVdialog: false,

      man_powersummarys: [],
      editman_powersummary: {},
      colleges: [],

      csvValidating: false,
      csvUploading: false,
      csvValidation: {
        checked: false,
        valid: false,
        totalRows: 0,
        errors: [],
        preview: []
      },

      snackbar: { show: false, color: "", icon: "", text: "" },

      headers: [
        { text: "สถานศึกษา", align: "left", value: "college_name" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "สถานะสรุปผล", align: "center", value: "summary_s" },
        { text: "จำนวน (อัตรา)", align: "center", value: "total_s" },
        { text: "แก้ไข", align: "center", value: "actions", sortable: false }
      ],

      summaryText: [
        { text: "เกินเกณฑ์ (Surplus)", value: "เกินเกณฑ์" },
        { text: "ขาดเกณฑ์ (Shortage)", value: "ขาดเกณฑ์" },
        { text: "พอดี (Balanced)", value: "พอดี" }
      ],

      allowedSummary: ["ขาดเกณฑ์", "เกินเกณฑ์", "พอดี"],

      data_syslog: {}
    };
  },

  computed: {
    stats() {
      const total = this.man_powersummarys.length;
      const shortage = this.man_powersummarys.filter(
        i => i.summary_s === "ขาดเกณฑ์"
      ).length;
      const surplus = this.man_powersummarys.filter(
        i => i.summary_s === "เกินเกณฑ์"
      ).length;
      const balanced = this.man_powersummarys.filter(
        i => i.summary_s === "พอดี"
      ).length;
      return { total, shortage, surplus, balanced };
    },
    time_stamp() {
      return Date.now();
    },
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return `${dd}/${mm}/${yyyy}/${time}`;
    },
    canImport() {
      return (
        !!this.file2 &&
        this.csvValidation.checked &&
        this.csvValidation.valid &&
        !this.csvValidating &&
        !this.csvUploading
      );
    }
  },

  async mounted() {
    await this.fetchInitialData();
    await this.man_powersummaryQueryAll();
  },

  methods: {
    async fetchInitialData() {
      let res = await this.$http.post("college.php", { ApiKey: this.ApiKey });
      this.colleges = res.data;
    },

    async man_powersummaryQueryAll() {
      this.loading = true;
      try {
        let res = await this.$http.post("man_powersummary.php", {
          ApiKey: this.ApiKey
        });
        this.man_powersummarys = res.data;
      } finally {
        this.loading = false;
      }
    },

    exportToExcel() {
      const data = this.man_powersummarys.map(item => ({
        สถานศึกษา: item.college_name,
        จังหวัด: item.province_name,
        สถานะสรุป: item.summary_s,
        จำนวน: item.total_s
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Manpower_Summary");
      XLSX.writeFile(wb, `Manpower_Summary_${this.time_stamp}.xlsx`);
    },

    async man_powersummaryCSV() {
      this.resetCsvDialogState();
      this.man_powersummaryCSVdialog = true;
    },

    closeCsvDialog() {
      this.man_powersummaryCSVdialog = false;
      this.resetCsvDialogState();
    },

    resetCsvDialogState() {
      this.file2 = null;
      this.csvValidating = false;
      this.csvUploading = false;
      this.csvValidation = {
        checked: false,
        valid: false,
        totalRows: 0,
        errors: [],
        preview: []
      };
    },

    onFileSelected(file) {
      this.csvValidation = {
        checked: false,
        valid: false,
        totalRows: 0,
        errors: [],
        preview: []
      };

      if (!file) return;

      if (!file.name.toLowerCase().endsWith(".csv")) {
        this.csvValidation.checked = true;
        this.csvValidation.valid = false;
        this.csvValidation.errors.push({
          row: 0,
          college_code: "",
          messages: ["ไฟล์ต้องเป็นนามสกุล .csv เท่านั้น"]
        });
        return;
      }

      this.validateCsvFile(file);
    },

    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => resolve(e.target.result);
        reader.onerror = () => reject(new Error("ไม่สามารถอ่านไฟล์ได้"));
        reader.readAsText(file, "UTF-8");
      });
    },

    parseCsvLine(line) {
      const result = [];
      let cur = "";
      let inQuotes = false;

      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        if (inQuotes) {
          if (char === '"') {
            if (line[i + 1] === '"') {
              cur += '"';
              i++;
            } else {
              inQuotes = false;
            }
          } else {
            cur += char;
          }
        } else if (char === '"') {
          inQuotes = true;
        } else if (char === ",") {
          result.push(cur);
          cur = "";
        } else {
          cur += char;
        }
      }
      result.push(cur);
      return result;
    },

    async validateCsvFile(file) {
      this.csvValidating = true;
      const errors = [];
      const preview = [];

      try {
        const text = await this.readFileAsText(file);

        if (text.includes("\uFFFD")) {
          errors.push({
            row: 0,
            college_code: "",
            messages: [
              "ไฟล์ไม่ใช่ UTF-8 encoding กรุณาบันทึกไฟล์เป็น UTF-8 (เช่น เปิดด้วย Excel แล้วเลือก Save As > CSV UTF-8) ก่อนนำเข้า"
            ]
          });
          this.finalizeCsvValidation(errors, preview, 0);
          return;
        }

        const lines = text
          .split(/\r\n|\n|\r/)
          .filter(l => l.trim() !== "");

        if (lines.length < 2) {
          errors.push({
            row: 0,
            college_code: "",
            messages: ["ไฟล์ไม่มีข้อมูล หรือมีเฉพาะบรรทัดหัวตาราง (header) เท่านั้น"]
          });
          this.finalizeCsvValidation(errors, preview, 0);
          return;
        }

        let header = this.parseCsvLine(lines[0]);
        header[0] = (header[0] || "").replace(/^\uFEFF/, "");

        if (header.length < 3) {
          errors.push({
            row: 1,
            college_code: "",
            messages: [
              `จำนวนคอลัมน์ไม่ถูกต้อง ต้องมีอย่างน้อย 3 คอลัมน์ (รหัสสถานศึกษา, สถานะ, จำนวน) แต่พบ ${header.length} คอลัมน์`
            ]
          });
        }

        const seenCodes = new Set();
        const totalRows = lines.length - 1;

        for (let i = 1; i < lines.length; i++) {
          const rowNumber = i + 1;
          const cols = this.parseCsvLine(lines[i]);

          let college_code = (cols[0] || "").trim();
          college_code = college_code.replace(/^\uFEFF/, "");
          const summary_s = (cols[1] || "").trim();
          const total_s = (cols[2] || "").trim();

          const rowErrors = [];

          if (!college_code) {
            rowErrors.push("รหัสวิทยาลัยไม่สามารถเว้นว่างได้");
          } else if (!/^\d+$/.test(college_code)) {
            rowErrors.push(
              `รหัสวิทยาลัยต้องเป็นตัวเลขเท่านั้น (พบ: "${college_code}")`
            );
          } else if (seenCodes.has(college_code)) {
            rowErrors.push(`รหัสวิทยาลัยซ้ำกับแถวก่อนหน้าในไฟล์ (${college_code})`);
          }
          if (college_code) seenCodes.add(college_code);

          if (summary_s && !this.allowedSummary.includes(summary_s)) {
            rowErrors.push(
              `สถานะต้องเป็นค่าใดค่าหนึ่งเท่านั้น: ขาดเกณฑ์, เกินเกณฑ์, พอดี (พบ: "${summary_s}")`
            );
          }

          if (total_s && !/^-?\d+$/.test(total_s)) {
            rowErrors.push(
              `จำนวนต้องเป็นตัวเลขจำนวนเต็ม (บวกหรือลบ) เท่านั้น (พบ: "${total_s}")`
            );
          }

          if (rowErrors.length > 0) {
            errors.push({
              row: rowNumber,
              college_code,
              messages: rowErrors
            });
          }

          if (preview.length < 5) {
            preview.push({
              row: rowNumber,
              college_code,
              summary_s,
              total_s,
              valid: rowErrors.length === 0
            });
          }
        }

        this.finalizeCsvValidation(errors, preview, totalRows);
      } catch (e) {
        errors.push({
          row: 0,
          college_code: "",
          messages: ["ไม่สามารถอ่านหรือประมวลผลไฟล์ได้: " + e.message]
        });
        this.finalizeCsvValidation(errors, preview, 0);
      }
    },

    finalizeCsvValidation(errors, preview, totalRows) {
      this.csvValidation = {
        checked: true,
        valid: errors.length === 0,
        totalRows,
        errors,
        preview
      };
      this.csvValidating = false;
    },

    async csvManpowerSubmit() {
      if (!this.canImport) return;

      this.csvUploading = true;
      try {
        let formData = new FormData();
        let filename = this.time_stamp + ".manpower.csv";
        formData.append("file", this.file2);
        formData.append("filename", "../HRvecfiles/" + filename);
        formData.append("ApiKey", this.ApiKey);

        let result = await this.$http.post(
          "man_powersummarycsv.php",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (result.data.status == true) {
          const msg = `นำเข้าข้อมูลเรียบร้อย (สำเร็จ ${result.data.success_count} รายการ${
            result.data.error_count ? `, ผิดพลาด ${result.data.error_count} รายการ` : ""
          })`;
          this.showSnackbar(msg, "success");
          this.man_powersummaryQueryAll();
          this.closeCsvDialog();
        } else {
          this.showSnackbar(result.data.message || "นำเข้าข้อมูลผิดพลาด", "error");
        }
      } catch (err) {
        if (err.message && err.message.includes("Network Error")) {
          this.showSnackbar(
            "ไฟล์มีการเปลี่ยนแปลงหลังจากเลือก กรุณาเลือกไฟล์ใหม่อีกครั้ง (หลีกเลี่ยงไฟล์ใน OneDrive/Google Drive และปิดไฟล์ใน Excel ก่อนอัพโหลด)",
            "error"
          );
        } else {
          this.showSnackbar("เกิดข้อผิดพลาดในการอัพโหลด", "error");
        }
        this.file2 = null;
        this.resetCsvDialogState();
      } finally {
        this.csvUploading = false;
      }
    },

    async man_powersummaryEdit(id_no) {
      let result = await this.$http.post("man_powersummary.php", {
        ApiKey: this.ApiKey,
        id_no: id_no
      });
      this.editman_powersummary = result.data;
      this.editman_powersummarydialog = true;
    },

    async editman_powersummarySubmit() {
      if (this.$refs.editman_powersummaryform.validate()) {
        this.editman_powersummary.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "man_powersummary.update.php",
          this.editman_powersummary
        );

        if (result.data.status == true) {
          this.showSnackbar("แก้ไขข้อมูลเรียบร้อย", "success");
          this.logSystem(
            "update",
            `${this.editman_powersummary.id_summary_s}:${this.editman_powersummary.college_code}`
          );
          this.man_powersummaryQueryAll();
          this.editman_powersummarydialog = false;
        } else {
          this.showSnackbar("แก้ไขข้อมูลผิดพลาด", "error");
        }
      }
    },

    async man_powersummaryClear() {
      this.ClearMan_powerdialog = true;
    },

    async ClearMan_powerSubmit() {
      let payload = { ApiKey: this.ApiKey };
      let result = await this.$http.post("man_powersummary.clear.php", payload);

      if (result.data.status == true) {
        this.showSnackbar("ล้างข้อมูลเรียบร้อย", "success");
        this.logSystem("Clear", "All Summary Data");
        this.man_powersummaryQueryAll();
        this.ClearMan_powerdialog = false;
      } else {
        this.showSnackbar("ล้างข้อมูลผิดพลาด", "error");
      }
    },

    getStatusColor(status) {
      if (status === "ขาดเกณฑ์") return "red";
      if (status === "เกินเกณฑ์") return "amber darken-2";
      if (status === "พอดี") return "green";
      return "grey";
    },
    getStatusIcon(status) {
      if (status === "ขาดเกณฑ์") return "mdi-arrow-down-bold";
      if (status === "เกินเกณฑ์") return "mdi-arrow-up-bold";
      return "mdi-check";
    },

    async logSystem(event, detail) {
      let userSession = JSON.parse(localStorage.getItem("user")) || {};
      this.data_syslog = {
        ApiKey: this.ApiKey,
        user_account: userSession.user_name || "unknown",
        event_log: event,
        page_log: "man_powersummary",
        table_log: "man_powersummary",
        detail_log: detail,
        date_times: this.date_today_log
      };
      await this.$http.post("data_syslog.insert.php", this.data_syslog);
    },

    showSnackbar(text, color) {
      this.snackbar = {
        show: true,
        text,
        color,
        icon: color === "success" ? "mdi-check-circle" : "mdi-alert"
      };
    }
  }
};
</script>

<style scoped>
.custom-table >>> thead th {
  font-weight: 600 !important;
  color: #333 !important;
  background-color: #f8f9fa;
}
.shadow-sm {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}
.bg-white {
  background-color: white;
}
</style>